const locale = {
	NO_MATCHING_RECORDS_FOUND: 'テーブル内のデータなし',
};

export default locale;
